import * as React from "react";
import { useContext } from "react";
import { IconButton, Badge, SxProps } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/NotificationsNone";
import PanelNotification from "../../../Notification/NotificationPanel/notification-panel";

export interface PageHeadNotificationsProps {
  transparent?: boolean;
}

const PageHeadNotifications: React.FC<PageHeadNotificationsProps> = (props) => {
  const [openPanelNotification, setOpenPanelNotification] = React.useState(false);

  const showPanelNotification = () => {
    setOpenPanelNotification(true);
  };
  const hidePanelNotification = () => {
    setOpenPanelNotification(false);
  };

  // used to display red badge if there is an error activity
  const [isError, setError] = React.useState(false);
  // used to display badge if activity not read
  const [activitiesNotRead, setActivitiesNotRead] = React.useState(false);
  const setErrorFromNotificationPanel = (isErrorFromChild: boolean, activitiesNotReadFromChild: boolean) => {
    // check to prevent re-rendering on same state
    if (isErrorFromChild !== isError) setError(isErrorFromChild);
    if (activitiesNotReadFromChild !== activitiesNotRead) setActivitiesNotRead(activitiesNotReadFromChild);
  };

  return (
    <>
      <IconButton onClick={showPanelNotification} id="tutorial-uikit-demo-notifications" size="small" color="ghost">
        {activitiesNotRead ? (
          <Badge variant="dot" color={isError ? "error" : "primary"}>
            <NotificationsIcon />
          </Badge>
        ) : (
          <NotificationsIcon />
        )}
      </IconButton>
      <PanelNotification
        open={openPanelNotification}
        onClose={hidePanelNotification}
        onGetActivitiesCallback={setErrorFromNotificationPanel}
      />
    </>
  );
};

export default PageHeadNotifications;
